
export class ThresholdUtils {
  static formatLabel(minValue: number, maxValue: number | null, noUpperBound: boolean): string {
    return (noUpperBound || maxValue === null) ? `${minValue} - ∞` : `${minValue} - ${maxValue}`;
  }

  static calculateTotalRange(bands: Array<{ minValue: number; maxValue: number | null; noUpperBound?: boolean }>): number {
    return bands.reduce((total, b) => {
      if (b.noUpperBound || b.maxValue === null) return total;
      return total + (b.maxValue - b.minValue);
    }, 0);
  }
}
